// import { Link } from 'react-router-dom';
import ProcessPage from 'components/ProcessPage';
import PropTypes from 'prop-types';
import React from 'react';
import { SOLUTION_ACCENT } from 'utils/constants';
import TemplateComponent from 'react-mustache-template-component';
import { template } from '../../mustache/invoiceDetails';
import { FormattedMessage } from 'react-intl';
import messages from 'utils/messages';
import { countries } from 'utils/countries';
import { dateFormatter5, dateFormatter4, getInvoiceFormat, getPriceFormat, getAddress1Info } from 'utils/common';
import ActionIcon from 'components/ActionIcon';
import {sortBy} from 'lodash'
import { ImportIcon } from 'images/common';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import LoadingIndicator from 'components/LoadingIndicator';

class FullBillEstimate extends React.Component {
  state = {
    isDownloading: false,
  };

  onDownload = () => {
    const { upcomingInvoice } = this.props;

    const input = document.getElementById('invoice-box');
    const invoiceDate = upcomingInvoice.invoiceDate;
    html2canvas(input, {scale: 2}).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      // eslint-disable-next-line
      const pdf = new jsPDF({});
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
      this.setState({ isDownloading: false });
      pdf.save(`bill-history-${dateFormatter5(invoiceDate)}.pdf`);
    });
  }

  printDocument = () => {
    this.setState({ isDownloading: true }, () => {
    });
    setTimeout(() => {
      this.onDownload();
    }, 1000)
  };

  getDescription = (planName) => {
    const {plans} = this.props;

    const selectedPlan = plans.find(plan => plan.name === planName);

    return selectedPlan && selectedPlan.description;
  }

  getPlanName = (planName, description) => {
    const {plans} = this.props;

    const selectedPlan = plans.find(plan => plan.name === planName);

    return (selectedPlan && selectedPlan.prettyName) || description;
  }

  getQuantity = (planName) => {
    const {plans} = this.props;

    const selectedPlan = plans.find(plan => plan.name === planName);

    return selectedPlan && `${selectedPlan && selectedPlan.quantity} ${selectedPlan && selectedPlan.unit}`;
  }

  render() {
    const {isDownloading} = this.state;
    const { upcomingInvoice, billing, workspace } = this.props;
    const data = {
      invoice: {
        ...upcomingInvoice,
        items: sortBy(upcomingInvoice.items, ['amount']).map((item) => ({
          ...item,
          startDate: dateFormatter4(item.startDate),
          endDate: dateFormatter4(item.endDate),
          amount: getPriceFormat(item.amount),
          name: this.getPlanName(item.planName, item.description),
          description: this.getDescription(item.planName),
          quantity: this.getQuantity(item.planName)
        })).reverse(),
        invoiceNumber: getInvoiceFormat(upcomingInvoice.invoiceNumber) || '',
        formattedInvoiceCreatedDate: dateFormatter4(
          upcomingInvoice.invoiceDate
        ),
        formattedInvoiceDueDate: dateFormatter4(upcomingInvoice.targetDate),
        invoiceItemAmount: getPriceFormat(upcomingInvoice.amount),
        formattedChargedAmount: getPriceFormat(upcomingInvoice.amount),
        formattedPaidAmount: getPriceFormat(upcomingInvoice.creditAdj),
        formattedBalance: getPriceFormat(upcomingInvoice.balance),
      },
      text: {
        ...upcomingInvoice,
        logo: 'data:image/jpeg;base64,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',
        companyName: `${billing.billingInformation.firstName} ${billing.billingInformation.lastName}` || '',
        companyAddress: billing.billingInformation && billing.billingInformation.address1 || 'No company address',
        companyAddress1: getAddress1Info(billing.billingInformation),
        companyCountry:
          billing.billingInformation && countries.find(
            (country) => country.value === billing.billingInformation.country
          ) && countries.find(
            (country) => country.value === billing.billingInformation.country
          ).label || 'No company country',
        companyCityProvincePostalCode:
          billing.billingInformation.city || 'No company city',
        invoiceTitle: 'Invoice',
        invoicePrefix: '#: ',
        invoiceNumber:
          upcomingInvoice.invoiceNumber || upcomingInvoice.invoiceId,
        invoiceDate: 'Created: ',
        invoiceCreationAdditionalMessage: 'Bank Payment',
        invoiceCreationTermsMessage: `Terms: Invoice due within Net ${workspace.paymentTerms} days`,
        invoiceCreationPaymentMethod: 'Payment',
        invoiceItemServicePeriod: 'Period',
        invoiceItemDescription: 'Description',
        invoiceItemAmount: 'Price',
        invoiceBalance: 'Amount due: ',
        invoiceAmountPaid: 'Applied balance: ',
        invoiceAmount: 'Subtotal: ',
        invoiceCreated: 'Created: ',
        invoiceDue: 'Due: ',
      },
      account: {
        name: billing.billingInformation.firstName || '-',
        contactName: billing.billingContact.name,
        contactEmail: billing.billingContact.email,
        companyName: workspace.organizationName || 'No company name',
        companyAddress: getAddress1Info(billing.billingInformation) || 'No company address',
        country:
          billing.billingInformation && countries.find(
            (country) => country.value === billing.billingInformation.country
          ) && countries.find(
            (country) => country.value === billing.billingInformation.country
          ).label || 'No company country',
        postalCode: billing.billingInformation.postCode || 'No postal code',
        city: billing.billingInformation.city || 'No city',
        ...upcomingInvoice,
      },
    };

    return (
      <ProcessPage
        onCancel={this.props.onClose}
        customClass="invoice-process-page"
      >
        {() => (
          <>
            <div className="headline">
              <h1 className="headline__title text-capitalize">{upcomingInvoice.status && upcomingInvoice.status} Invoice {getInvoiceFormat(upcomingInvoice.invoiceNumber)}</h1>
              <h3 className="headline__subtitle">
                {this.props.workspace.name}
              </h3>
            </div>
          <>
            <div className="invoice-print">
              <ActionIcon
                onClick={this.printDocument}
                isLoading={this.state.isDownloading}
                disabled={this.state.isDownloading}
                icon={<ImportIcon />}
                text={isDownloading ? 'Downloading...' : <FormattedMessage {...messages.download} />}
              />
            </div>
            <TemplateComponent template={template} data={data} />
            </>
          </>
        )}
      </ProcessPage>
    );
  }
}

FullBillEstimate.propTypes = {
  color: PropTypes.string,
};

FullBillEstimate.defaultProps = {
  color: SOLUTION_ACCENT,
};

export default FullBillEstimate;
